import { __module as O } from "./index316.js";
/*!
 * TOAST UI Editor : Code Syntax Highlight Plugin
 * @version 3.1.0 | Fri Aug 05 2022
 * @author NHN Cloud FE Development Lab <dl_javascript@nhn.com>
 * @license MIT
 */
var j;
function yt() {
  return j ? O.exports : (j = 1, (function() {
    var z = {
      /***/
      928: (
        /***/
        (function(r, o, i) {
          var d = i(322);
          function f(u, h, g) {
            var p, y;
            if (g = g || 0, !d(h))
              return -1;
            if (Array.prototype.indexOf)
              return Array.prototype.indexOf.call(h, u, g);
            for (y = h.length, p = g; g >= 0 && p < y; p += 1)
              if (h[p] === u)
                return p;
            return -1;
          }
          r.exports = f;
        })
      ),
      /***/
      690: (
        /***/
        (function(r, o, i) {
          var d = i(322), f = i(893), u = i(956);
          function h(g, p, y) {
            d(g) ? f(g, p, y) : u(g, p, y);
          }
          r.exports = h;
        })
      ),
      /***/
      893: (
        /***/
        (function(r) {
          function o(i, d, f) {
            var u = 0, h = i.length;
            for (f = f || null; u < h && d.call(f, i[u], u, i) !== !1; u += 1)
              ;
          }
          r.exports = o;
        })
      ),
      /***/
      956: (
        /***/
        (function(r) {
          function o(i, d, f) {
            var u;
            f = f || null;
            for (u in i)
              if (i.hasOwnProperty(u) && d.call(f, i[u], u, i) === !1)
                break;
          }
          r.exports = o;
        })
      ),
      /***/
      990: (
        /***/
        (function(r, o, i) {
          var d = i(893);
          function f(u) {
            var h;
            try {
              h = Array.prototype.slice.call(u);
            } catch {
              h = [], d(u, function(p) {
                h.push(p);
              });
            }
            return h;
          }
          r.exports = f;
        })
      ),
      /***/
      24: (
        /***/
        (function(r, o, i) {
          var d = i(322), f = i(929);
          function u(h, g) {
            if (g = d(g) ? g.join(" ") : g, g = g.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), f(h.className.baseVal)) {
              h.className = g;
              return;
            }
            h.className.baseVal = g;
          }
          r.exports = u;
        })
      ),
      /***/
      204: (
        /***/
        (function(r, o, i) {
          var d = i(690), f = i(928), u = i(902), h = i(24);
          function g(p) {
            var y = Array.prototype.slice.call(arguments, 1), B = p.classList, w = [], C;
            if (B) {
              d(y, function(x) {
                p.classList.add(x);
              });
              return;
            }
            C = u(p), C && (y = [].concat(C.split(/\s+/), y)), d(y, function(x) {
              f(x, w) < 0 && w.push(x);
            }), h(p, w);
          }
          r.exports = g;
        })
      ),
      /***/
      522: (
        /***/
        (function(r, o, i) {
          var d = i(758), f = i(690);
          function u(h, g, p) {
            var y = h.style;
            if (d(g)) {
              y[g] = p;
              return;
            }
            f(g, function(B, w) {
              y[w] = B;
            });
          }
          r.exports = u;
        })
      ),
      /***/
      902: (
        /***/
        (function(r, o, i) {
          var d = i(929);
          function f(u) {
            return !u || !u.className ? "" : d(u.className.baseVal) ? u.className : u.className.baseVal;
          }
          r.exports = f;
        })
      ),
      /***/
      714: (
        /***/
        (function(r, o, i) {
          var d = i(928), f = i(902);
          function u(h, g) {
            var p;
            return h.classList ? h.classList.contains(g) : (p = f(h).split(/\s+/), d(g, p) > -1);
          }
          r.exports = u;
        })
      ),
      /***/
      462: (
        /***/
        (function(r, o, i) {
          var d = i(893), f = i(928), u = i(902), h = i(24);
          function g(p) {
            var y = Array.prototype.slice.call(arguments, 1), B = p.classList, w, C;
            if (B) {
              d(y, function(x) {
                B.remove(x);
              });
              return;
            }
            w = u(p).split(/\s+/), C = [], d(w, function(x) {
              f(x, y) < 0 && C.push(x);
            }), h(p, C);
          }
          r.exports = g;
        })
      ),
      /***/
      322: (
        /***/
        (function(r) {
          function o(i) {
            return i instanceof Array;
          }
          r.exports = o;
        })
      ),
      /***/
      294: (
        /***/
        (function(r) {
          function o(i) {
            return i instanceof Function;
          }
          r.exports = o;
        })
      ),
      /***/
      758: (
        /***/
        (function(r) {
          function o(i) {
            return typeof i == "string" || i instanceof String;
          }
          r.exports = o;
        })
      ),
      /***/
      929: (
        /***/
        (function(r) {
          function o(i) {
            return i === void 0;
          }
          r.exports = o;
        })
      )
      /******/
    }, D = {};
    function v(r) {
      var o = D[r];
      if (o !== void 0)
        return o.exports;
      var i = D[r] = {
        /******/
        // no module.id needed
        /******/
        // no module.loaded needed
        /******/
        exports: {}
        /******/
      };
      return z[r](i, i.exports, v), i.exports;
    }
    (function() {
      v.n = function(r) {
        var o = r && r.__esModule ? (
          /******/
          function() {
            return r.default;
          }
        ) : (
          /******/
          function() {
            return r;
          }
        );
        return v.d(o, { a: o }), o;
      };
    })(), (function() {
      v.d = function(r, o) {
        for (var i in o)
          v.o(o, i) && !v.o(r, i) && Object.defineProperty(r, i, { enumerable: !0, get: o[i] });
      };
    })(), (function() {
      v.o = function(r, o) {
        return Object.prototype.hasOwnProperty.call(r, o);
      };
    })();
    var H = {};
    (function() {
      v.d(H, {
        default: function() {
          return (
            /* binding */
            lt
          );
        }
      });
      var r = v(294), o = /* @__PURE__ */ v.n(r), i = 3;
      function d(e) {
        return {
          codeBlock: function(t) {
            var n = t, s = n.fenceLength, a = n.info, c = a ? a.split(/\s+/) : [], l = [], E = {};
            s > i && (E["data-backticks"] = s);
            var m = t.literal;
            if (c.length && c[0].length) {
              var L = c[0];
              l.push("lang-" + L), E["data-language"] = L;
              var b = e.languages[L];
              b && (m = e.highlight(t.literal, b, L));
            }
            return [
              { type: "openTag", tagName: "pre", classNames: l },
              { type: "openTag", tagName: "code", attributes: E },
              { type: "html", content: m },
              { type: "closeTag", tagName: "code" },
              { type: "closeTag", tagName: "pre" }
            ];
          }
        };
      }
      var f = v(758), u = /* @__PURE__ */ v.n(f);
      function h(e) {
        return e.reduce(function(t, n) {
          return t.concat(Array.isArray(n) ? h(n) : n);
        }, []);
      }
      var g = function(e, t) {
        for (var n = 0, s = t.length, a = e.length; n < s; n++, a++)
          e[a] = t[n];
        return e;
      }, p = "codeBlock";
      function y(e) {
        var t = [];
        return e.descendants(function(n, s) {
          n.isBlock && n.type.name === p && t.push({ node: n, pos: s });
        }), t;
      }
      function B(e, t) {
        return t === void 0 && (t = []), u()(e) ? [{ text: e, classes: t }] : e.map(function(n) {
          var s = n, a = s.type, c = s.alias, l = [], E = [];
          a && (l = ["token", a]), c && (E = u()(c) ? [c] : c);
          var m = g(g(g([], t), l), E);
          return u()(n) ? {
            text: n,
            classes: m
          } : B(n.content, m);
        });
      }
      function w(e, t, n) {
        var s = t.pmView, a = [], c = y(e);
        return c.forEach(function(l) {
          var E = l.pos, m = l.node, L = m.attrs.language, b = n.languages[L], ht = b ? n.tokenize(m.textContent, b) : [], ft = h(B(ht)), I = E + 1;
          ft.forEach(function(V) {
            var pt = V.text, dt = V.classes, R = I, U = R + pt.length;
            I = U;
            var K = dt.join(" "), vt = s.Decoration.inline(R, U, {
              class: K
            });
            K.length && a.push(vt);
          });
        }), s.DecorationSet.create(e, a);
      }
      function C(e, t) {
        return new e.pmState.Plugin({
          state: {
            init: function(n, s) {
              var a = s.doc;
              return w(a, e, t);
            },
            apply: function(n, s) {
              return n.docChanged ? w(n.doc, e, t) : s.map(n.mapping, n.doc);
            }
          },
          props: {
            decorations: function(n) {
              return this.getState(n);
            }
          }
        });
      }
      var x = v(204), A = /* @__PURE__ */ v.n(x);
      function S(e) {
        return parseInt(e, 10);
      }
      function W(e, t, n) {
        var s = S(e.left), a = S(e.top), c = S(e.width) + S(e.paddingLeft) + S(e.paddingRight), l = S(e.height) + S(e.paddingTop) + S(e.paddingBottom);
        return t >= s && t <= s + c && n >= a && n <= a + l;
      }
      function G(e) {
        e.parentNode && e.parentNode.removeChild(e);
      }
      var X = "toastui-editor-";
      function P() {
        for (var e = [], t = 0; t < arguments.length; t++)
          e[t] = arguments[t];
        return e.map(function(n) {
          return "" + X + n;
        }).join(" ");
      }
      var Y = v(522), N = /* @__PURE__ */ v.n(Y), J = v(462), M = /* @__PURE__ */ v.n(J), Q = v(714), Z = /* @__PURE__ */ v.n(Q), $ = v(990), q = /* @__PURE__ */ v.n($), tt = v(928), k = /* @__PURE__ */ v.n(tt), et = "code-block-language", nt = "code-block-language-input", it = "code-block-language-list", T = "data-language", F = 10;
      function at(e) {
        return e.map(function(t) {
          return '<button type="button" data-language="' + t + '">' + t + "</button>";
        }).join("");
      }
      var rt = (
        /** @class */
        (function() {
          function e(t, n, s) {
            var a = this;
            this.buttons = [], this.prevStoredLanguage = "", this.onSelectToggleButton = function(c) {
              var l = c.target, E = getComputedStyle(l, ":after"), m = c.offsetX, L = c.offsetY;
              W(E, m, L) && (c.preventDefault(), a.toggleFocus());
            }, this.onSelectLanguageButtons = function(c) {
              var l = c.target, E = l.getAttribute(T);
              E && a.selectLanguage(E);
            }, this.handleKeydown = function(c) {
              var l = c.key;
              l === "ArrowUp" ? (a.selectPrevLanguage(), c.preventDefault()) : l === "ArrowDown" ? (a.selectNextLanguage(), c.preventDefault()) : l === "Enter" || l === "Tab" ? (a.storeInputLanguage(), c.preventDefault()) : a.hideList();
            }, this.showLangugaeSelectBox = function(c, l) {
              var E = c.top, m = c.right;
              l && a.setLanguage(l), a.show();
              var L = a.input.parentElement.getBoundingClientRect().width;
              N()(a.wrapper, {
                top: E + F + "px",
                left: m - L - F + "px"
              }), a.toggleFocus();
            }, this.rootEl = t, this.eventEmitter = n, this.languages = s, this.createElement(), this.bindDOMEvent(), this.bindEvent();
          }
          return e.prototype.createElement = function() {
            this.wrapper = document.createElement("div"), A()(this.wrapper, P(et)), this.createInputElement(), this.createLanguageListElement(), this.rootEl.appendChild(this.wrapper), this.hide();
          }, e.prototype.createInputElement = function() {
            var t = document.createElement("span");
            A()(t, P(nt));
            var n = document.createElement("input");
            n.type = "text", n.setAttribute("maxlength", "20"), this.input = n, t.appendChild(this.input), this.wrapper.appendChild(t);
          }, e.prototype.createLanguageListElement = function() {
            this.list = document.createElement("div"), A()(this.list, P(it));
            var t = document.createElement("div");
            A()(t, "buttons"), t.innerHTML = at(this.languages), this.buttons = q()(t.children), this.list.appendChild(t), this.wrapper.appendChild(this.list), this.activateButtonByIndex(0), this.hideList();
          }, e.prototype.bindDOMEvent = function() {
            var t = this;
            this.wrapper.addEventListener("mousedown", this.onSelectToggleButton), this.input.addEventListener("keydown", this.handleKeydown), this.input.addEventListener("focus", function() {
              return t.activateSelectBox();
            }), this.input.addEventListener("blur", function() {
              return t.inactivateSelectBox();
            }), this.list.addEventListener("mousedown", this.onSelectLanguageButtons);
          }, e.prototype.bindEvent = function() {
            this.eventEmitter.listen("showCodeBlockLanguages", this.showLangugaeSelectBox);
          }, e.prototype.activateSelectBox = function() {
            A()(this.wrapper, "active"), N()(this.list, { display: "block" });
          }, e.prototype.inactivateSelectBox = function() {
            this.input.value = this.prevStoredLanguage, M()(this.wrapper, "active"), this.hideList();
          }, e.prototype.toggleFocus = function() {
            Z()(this.wrapper, "active") ? this.input.blur() : this.input.focus();
          }, e.prototype.storeInputLanguage = function() {
            var t = this.input.value;
            this.setLanguage(t), this.hideList(), this.eventEmitter.emit("selectLanguage", t);
          }, e.prototype.activateButtonByIndex = function(t) {
            this.currentButton && M()(this.currentButton, "active"), this.buttons.length && (this.currentButton = this.buttons[t], this.input.value = this.currentButton.getAttribute(T), A()(this.currentButton, "active"), this.currentButton.scrollIntoView());
          }, e.prototype.selectLanguage = function(t) {
            this.input.value = t, this.storeInputLanguage();
          }, e.prototype.selectPrevLanguage = function() {
            var t = k()(this.currentButton, this.buttons) - 1;
            t < 0 && (t = this.buttons.length - 1), this.activateButtonByIndex(t);
          }, e.prototype.selectNextLanguage = function() {
            var t = k()(this.currentButton, this.buttons) + 1;
            t >= this.buttons.length && (t = 0), this.activateButtonByIndex(t);
          }, e.prototype.hideList = function() {
            N()(this.list, { display: "none" });
          }, e.prototype.show = function() {
            N()(this.wrapper, { display: "inline-block" });
          }, e.prototype.hide = function() {
            N()(this.wrapper, { display: "none" });
          }, e.prototype.setLanguage = function(t) {
            this.prevStoredLanguage = t, this.input.value = t;
            var n = this.buttons.filter(function(a) {
              return a.getAttribute(T) === t;
            });
            if (n.length) {
              var s = k()(n[0], this.buttons);
              this.activateButtonByIndex(s);
            }
          }, e.prototype.destroy = function() {
            G(this.wrapper), this.eventEmitter.removeEventHandler("showCodeBlockLanguages", this.showLangugaeSelectBox);
          }, e;
        })()
      ), _ = function() {
        return _ = Object.assign || function(e) {
          for (var t, n = 1, s = arguments.length; n < s; n++) {
            t = arguments[n];
            for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
          }
          return e;
        }, _.apply(this, arguments);
      }, st = "ww-code-block-highlighting";
      function ot(e) {
        var t = e.htmlAttrs, n = e.classNames;
        return _(_({}, t), { class: n ? n.join(" ") : null });
      }
      var ut = (
        /** @class */
        (function() {
          function e(t, n, s, a, c) {
            var l = this;
            this.node = t, this.view = n, this.getPos = s, this.eventEmitter = a, this.languages = c, this.contentDOM = null, this.languageSelectBox = null, this.onSelectLanguage = function(E) {
              l.languageEditing && l.changeLanguage(E);
            }, this.onClickEditingButton = function(E) {
              var m = E.target, L = getComputedStyle(m, ":after");
              if (L.backgroundImage !== "none" && o()(l.getPos)) {
                var b = l.view.coordsAtPos(l.getPos());
                l.openLanguageSelectBox(b);
              }
            }, this.finishLanguageEditing = function() {
              l.languageEditing && l.reset();
            }, this.node = t, this.view = n, this.getPos = s, this.eventEmitter = a, this.languageEditing = !1, this.languages = c, this.createElement(), this.bindDOMEvent(), this.bindEvent();
          }
          return e.prototype.createElement = function() {
            var t = this.node.attrs.language, n = document.createElement("div");
            n.setAttribute("data-language", t || "text"), A()(n, P(st));
            var s = this.createCodeBlockElement(), a = s.firstChild;
            t && (A()(s, "language-" + t), A()(a, "language-" + t)), n.appendChild(s), this.dom = n, this.contentDOM = a;
          }, e.prototype.createCodeBlockElement = function() {
            var t = document.createElement("pre"), n = document.createElement("code"), s = this.node.attrs.language, a = ot(this.node.attrs);
            return s && n.setAttribute("data-language", s), Object.keys(a).forEach(function(c) {
              a[c] && t.setAttribute(c, a[c]);
            }), t.appendChild(n), t;
          }, e.prototype.bindDOMEvent = function() {
            this.dom && (this.dom.addEventListener("click", this.onClickEditingButton), this.view.dom.addEventListener("mousedown", this.finishLanguageEditing), window.addEventListener("resize", this.finishLanguageEditing));
          }, e.prototype.bindEvent = function() {
            this.eventEmitter.listen("selectLanguage", this.onSelectLanguage), this.eventEmitter.listen("scroll", this.finishLanguageEditing), this.eventEmitter.listen("finishLanguageEditing", this.finishLanguageEditing);
          }, e.prototype.openLanguageSelectBox = function(t) {
            this.languageSelectBox = new rt(this.view.dom.parentElement, this.eventEmitter, this.languages), this.eventEmitter.emit("showCodeBlockLanguages", t, this.node.attrs.language), this.languageEditing = !0;
          }, e.prototype.changeLanguage = function(t) {
            if (o()(this.getPos)) {
              this.reset();
              var n = this.getPos(), s = this.view.state.tr;
              s.setNodeMarkup(n, null, { language: t }), this.view.dispatch(s);
            }
          }, e.prototype.reset = function() {
            this.languageSelectBox && (this.languageSelectBox.destroy(), this.languageSelectBox = null), this.languageEditing = !1;
          }, e.prototype.stopEvent = function() {
            return !0;
          }, e.prototype.update = function(t) {
            return t.sameMarkup(this.node) ? (this.node = t, !0) : !1;
          }, e.prototype.destroy = function() {
            this.reset(), this.dom && (this.dom.removeEventListener("click", this.onClickEditingButton), this.view.dom.removeEventListener("mousedown", this.finishLanguageEditing), window.removeEventListener("resize", this.finishLanguageEditing)), this.eventEmitter.removeEventHandler("selectLanguage", this.onSelectLanguage), this.eventEmitter.removeEventHandler("scroll", this.finishLanguageEditing), this.eventEmitter.removeEventHandler("finishLanguageEditing", this.finishLanguageEditing);
          }, e;
        })()
      );
      function ct(e) {
        return function(t, n, s, a) {
          return new ut(t, n, s, a, e);
        };
      }
      function gt(e, t) {
        if (t) {
          var n = e.eventEmitter, s = t.highlighter;
          n.addEventType("showCodeBlockLanguages"), n.addEventType("selectLanguage"), n.addEventType("finishLanguageEditing");
          var a = s.languages, c = Object.keys(a).filter(function(l) {
            return !o()(a[l]);
          });
          return {
            toHTMLRenderers: d(s),
            wysiwygPlugins: [function() {
              return C(e, s);
            }],
            wysiwygNodeViews: {
              codeBlock: ct(c)
            }
          };
        }
        return {};
      }
      typeof window !== void 0 && (window.Prism = window.Prism || {}, window.Prism.manual = !0);
      var lt = gt;
    })(), O.exports = H.default;
  })(), O.exports);
}
export {
  yt as __require
};
